import {FormGroup} from '@angular/forms';

export function passwordMatchValidator(group: FormGroup) {
    const password = group.controls.password.value;
    const confirmPassword = group.controls.confirmPassword.value;
    const valid = (password === confirmPassword) && (password.length > 0);
    return valid ? null : {dontMatch: !valid};
}
